import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  activeTabIndex: 0,
  isFormDataChanged: null,
  userId: null,
  mode: null,
  availableForRouting: false,
  isInitDataLoaded: false,
};

const userFormSlice = createSlice({
  name: 'userForm',
  initialState: initialState,
  reducers: {
    clearUserFormUpdateComponent(state) {
      state.isLoading = false;
      state.isFormDataChanged = null;
      state.userId = null;
      state.mode = null;
      state.availableForRouting = false;
    },
    userFormUpdateComponent(state, { payload }) {
      state.isLoading = Object.prototype.hasOwnProperty.call(
        payload,
        'isLoading'
      )
        ? payload.isLoading
        : state.isLoading;
      state.activeTabIndex = Object.prototype.hasOwnProperty.call(
        payload,
        'activeTabIndex'
      )
        ? payload.activeTabIndex
        : state.activeTabIndex;
      state.isFormDataChanged = Object.prototype.hasOwnProperty.call(
        payload,
        'isFormDataChanged'
      )
        ? payload.isFormDataChanged
        : state.isFormDataChanged;
      state.userId = Object.prototype.hasOwnProperty.call(payload, 'userId')
        ? payload.userId
        : state.userId;
      state.mode = Object.prototype.hasOwnProperty.call(payload, 'mode')
        ? payload.mode
        : state.mode;
      state.availableForRouting = Object.prototype.hasOwnProperty.call(
        payload,
        'availableForRouting'
      )
        ? payload.availableForRouting
        : state.availableForRouting;
      state.isInitDataLoaded = Object.prototype.hasOwnProperty.call(
        payload,
        'isInitDataLoaded'
      )
        ? payload.isInitDataLoaded
        : state.isInitDataLoaded;
    },
  },
});

export const { userFormUpdateComponent, clearUserFormUpdateComponent } =
  userFormSlice.actions;

export const userFormReducer = userFormSlice.reducer;
